namespace RedBullMOBILE360.CVM {
    export interface OfferRedemptionRow {
        Id?: number;
        SegmentId?: number;
        Msisdn?: string;
        RedemptionDate?: string;
        SegmentTitle?: string;
        SegmentOfferId?: string;
    }

    export namespace OfferRedemptionRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Msisdn';
        export const localTextPrefix = 'CVM.OfferRedemption';
        export const deletePermission = 'CVM:OfferRedemption';
        export const insertPermission = 'CVM:OfferRedemption';
        export const readPermission = 'CVM:OfferRedemption';
        export const updatePermission = 'CVM:OfferRedemption';

        export declare const enum Fields {
            Id = "Id",
            SegmentId = "SegmentId",
            Msisdn = "Msisdn",
            RedemptionDate = "RedemptionDate",
            SegmentTitle = "SegmentTitle",
            SegmentOfferId = "SegmentOfferId"
        }
    }
}
